export enum ApplicationOptionsEnum {
	ADMINISTRATION = 'ADMINISTRATION',
	TAXES_FONCIERES = 'TAXES_FONCIERES',
	SALAIRES_GARDIENS = 'SALAIRES_GARDIENS',
	DEPENSES_MANUELLES = 'DEPENSES_MANUELLES'
}